// extracted by mini-css-extract-plugin
export default {"rocketImage":"rocket_rocketImage__1NFeT","form":"rocket_form__l75MA","backIcon":"rocket_backIcon__EZRQv"};